// A Livewire request that arrives after a Nova impersonation's time limit gets a JSON 403
// from App\Http\Middleware\EndExpiredNovaImpersonation: {error: 'impersonation_time_limit',
// redirect}. A redirect would not work there (Livewire would JSON.parse the HTML page and
// throw), and a bare 4xx would show its raw body in Livewire's error modal, so the fail
// hook in livewire-error-reporter.js asks this module where to send the browser instead.

export const IMPERSONATION_TIME_LIMIT_ERROR = 'impersonation_time_limit';

/**
 * The same-origin URL to navigate to, or null when this failure is not the time limit.
 *
 * @param {number} status
 * @param {string|null} content  the raw response body Livewire hands its fail hook
 * @param {string} origin        window.location.origin
 * @returns {string|null}
 */
export function impersonationTimeLimitRedirect(status, content, origin) {
    if (status !== 403 || typeof content !== 'string' || content === '') return null;

    let body;
    try {
        body = JSON.parse(content);
    } catch (_) {
        return null;
    }

    if (!body || body.error !== IMPERSONATION_TIME_LIMIT_ERROR || typeof body.redirect !== 'string') {
        return null;
    }

    // Only ever navigate within this app, whatever the body says.
    let url;
    try {
        url = new URL(body.redirect, origin);
    } catch (_) {
        return null;
    }

    return url.origin === origin ? url.href : null;
}
